import React from 'react'
import { Breadcrumbs } from '@lightspeed/design-system-react'
import { TFunction } from '@transifex/react'
import { createUseTranslationMap } from '@vend/react-utilities'
import { STEPS } from '../types'

interface StepBreadcrumbsProps {
  step: STEPS
  isAddingCustomer?: boolean
}

const getActiveBreadcrumb = (
  step: STEPS,
  isAddingCustomer: boolean,
  breadcrumbs: string[]
) => {
  if (step === STEPS.DETAILS && !isAddingCustomer) {
    return breadcrumbs[step - 2]
  }
  return breadcrumbs[step - 1]
}

let translationMap: Record<string, string> = {}

// This function will be passed an up to date instance of `t` from useT()
const buildTranslationMap = (t: TFunction) => {
  translationMap = {
    METHOD: t('Method', {
      _context: 'Breadcrumb for the fulfillment method step in the modal',
    }),
    CUSTOMER: t('Customer', {
      _context: 'Breadcrumb for the customer step in the modal',
    }),
    ADD: t('Add', {
      _context: 'Breadcrumb for the add step in the fulfillment modal',
    }),
    FULFILMENT_DETAILS: t('Fulfillment details', {
      _context:
        'Breadcrumb for the fulfillment details step in the fulfillment modal',
    }),
  }
}

// Create a hook for use with a map of strings requiring translation
const useGetBreadcrumbsMessage = createUseTranslationMap(
  buildTranslationMap,
  (key: string) => translationMap[key]
)

export const StepBreadcrumbsLegacy: React.FC<StepBreadcrumbsProps> = ({
  step,
  isAddingCustomer = false,
}) => {
  const getBreadcrumbsMessage = useGetBreadcrumbsMessage()

  const BREADCRUMBS = [
    getBreadcrumbsMessage('METHOD'),
    getBreadcrumbsMessage('CUSTOMER'),
    getBreadcrumbsMessage('FULFILMENT_DETAILS'),
  ]

  const BREADCRUMBS_WITH_ADD = [
    getBreadcrumbsMessage('METHOD'),
    getBreadcrumbsMessage('CUSTOMER'),
    getBreadcrumbsMessage('ADD'),
    getBreadcrumbsMessage('FULFILMENT_DETAILS'),
  ]

  const breadcrumbs = isAddingCustomer ? BREADCRUMBS_WITH_ADD : BREADCRUMBS

  return (
    <Breadcrumbs
      breadcrumbs={breadcrumbs}
      activeBreadcrumb={getActiveBreadcrumb(
        step,
        isAddingCustomer,
        breadcrumbs
      )}
    />
  )
}
